module.exports = __webpack_public_path__ + "img/60ne.b2a94ee0.svg";